import { ReactChild } from "react"
import { EPage } from "../../types"
import '../components.scss'


type ContentProps = {
    page: EPage,
    children: ReactChild
}

export const Content: React.FC<ContentProps> = ({ page, children }) => {


    return (
        <div className={`content ${page === EPage.STATS ? 'widther' : ''}`}>
            {children }
        </div>
    )
}